export enum ProjectSize {
  UNITS_5_TO_49 = "5-49 units",
  UNITS_50_TO_199 = "50-199 units",
  UNITS_200_TO_499 = "200-499 units",
  UNITS_500_TO_999 = "500-999 units",
  UNITS_1000_PLUS = "1000+ units",
}
